import {
  createTovGlobalQueryKey,
  createTovGuestQueryKey,
} from '@tov-plus/frontend-data';

export const guestQueryKeys = {
  bootstrap: (occasionSlug: string, guestToken: string) =>
    createTovGuestQueryKey(occasionSlug, guestToken, 'bootstrap'),
  rsvp: (
    occasionSlug: string,
    guestToken: string,
    ...parts: readonly string[]
  ) => createTovGuestQueryKey(occasionSlug, guestToken, 'rsvp', ...parts),
  forms: (occasionSlug: string, guestToken: string) =>
    createTovGuestQueryKey(occasionSlug, guestToken, 'forms'),
  registry: (occasionSlug: string, guestToken: string) =>
    createTovGuestQueryKey(occasionSlug, guestToken, 'registry'),
  sharedPlanning: (occasionSlug: string, guestToken: string) =>
    createTovGuestQueryKey(occasionSlug, guestToken, 'shared-planning'),
  messages: (occasionSlug: string, guestToken: string) =>
    createTovGuestQueryKey(occasionSlug, guestToken, 'messages'),
  messagingInbox: (occasionSlug: string, guestToken: string) =>
    createTovGuestQueryKey(occasionSlug, guestToken, 'messaging-inbox'),
  gallery: (occasionSlug: string, guestToken: string) =>
    createTovGuestQueryKey(occasionSlug, guestToken, 'gallery'),
  schedule: (occasionSlug: string, guestToken: string) =>
    createTovGuestQueryKey(occasionSlug, guestToken, 'schedule'),
  today: (occasionSlug: string, guestToken: string) =>
    createTovGuestQueryKey(occasionSlug, guestToken, 'today'),
  locations: (
    occasionSlug: string,
    guestToken: string,
    ...parts: readonly string[]
  ) => createTovGuestQueryKey(occasionSlug, guestToken, 'locations', ...parts),
  travelPacket: (occasionSlug: string, guestToken: string) =>
    createTovGuestQueryKey(occasionSlug, guestToken, 'travel-packet'),
  seating: (occasionSlug: string, guestToken: string) =>
    createTovGuestQueryKey(occasionSlug, guestToken, 'seating'),
  inviteProfile: (occasionSlug: string, guestToken: string) =>
    createTovGuestQueryKey(occasionSlug, guestToken, 'invite-profile'),
  search: (occasionSlug: string, guestToken: string, query: string) =>
    createTovGuestQueryKey(occasionSlug, guestToken, 'search', query),
  reviewerPreview: (occasionSlug: string, reviewerToken: string) =>
    createTovGlobalQueryKey(
      'guests',
      'reviewer-preview',
      occasionSlug,
      reviewerToken,
    ),
  galleryShare: (shareToken: string) =>
    createTovGlobalQueryKey('guests', 'gallery-share', shareToken),
  publicInvite: (token: string) =>
    createTovGlobalQueryKey('guests', 'public-invite', token),
  publicDeliveryInvite: (deliveryToken: string) =>
    createTovGlobalQueryKey('guests', 'public-delivery-invite', deliveryToken),
  drafts: (occasionSlug: string, guestToken: string) =>
    createTovGuestQueryKey(occasionSlug, guestToken, 'drafts'),
  support: (occasionSlug: string, guestToken: string) =>
    createTovGuestQueryKey(occasionSlug, guestToken, 'support'),
  access: createTovGlobalQueryKey('guests', 'access'),
};
